import { render, staticRenderFns } from "./NoticeListPanel.vue?vue&type=template&id=600db885&scoped=true&lang=pug&"
import script from "./NoticeListPanel.vue?vue&type=script&lang=ts&"
export * from "./NoticeListPanel.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeListPanel.vue?vue&type=style&index=0&id=600db885&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600db885",
  null
  
)

export default component.exports